<template>
    <div class="row">
        <div class="mb-3 col-md-6 col-sm-12">
            <div class="card h-100">
                <div class="card-header">
                    <h5 class="card-title">{{$t('home.myLastPaticipations')}}</h5>
                </div>
                <div class="card-body">
                    <div v-if="myParticipations.length">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" class="w-50">{{$t('home.event')}}</th>
                                    <th scope="col">{{$t('home.participation')}}</th>
                                    <th scope="col">{{$t('home.startTime')}}</th>
                                    <th scope="col">{{$t('home.endTime')}}</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in myParticipations" :key="'myEvents'+index">
                                    <th scope="row">{{index+1}}</th>
                                    <td>{{item.eventName}}</td>
                                    <td>{{item.participationType}}</td>
                                    <td>{{$moment(item.eventStartDate).format('DD MMM YYYY')}}</td>
                                    <td>{{$moment(item.eventEndDate).format('DD MMM YYYY')}}</td>
                                    <td>
                                        <router-link :to="{ path: `/registers/events/edit/${item.registerEntityId}`}" replace :title="$t('buttons.open')">
                                            <i class="fa fa-external-link-alt"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <span class="text-danger">{{$t('home.noData')}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <router-link :to="{ path: '/account?tab=participantsTab'}" replace class="card-link">{{$t('home.showMore')}}</router-link>
                </div>
            </div>
        </div>
        <div class="mb-3 col-md-6 col-sm-12">
            <div class="card h-100">
                <div class="card-header">
                    <h5 class="card-title">{{$t('home.myForms')}}</h5>
                </div>
                <div class="card-body">
                    <div v-if="myForms.length">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">{{$t('home.myForms')}}</th>
                                    <th scope="col">{{$t('home.type')}}</th>
                                    <th scope="col">{{$t('home.event')}}</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in myForms" :key="'myEvents'+index">
                                    <th scope="row">{{index+1}}</th>
                                    <td>{{item.formName}}</td>
                                    <td>{{item.formType}}</td>
                                    <td>{{item.eventName}}</td>
                                    <td>
                                        <router-link :to="{ path: `/forms/entryDetails?id=${item.formToRegisterEntityId}&entryId=${item.id}&name=${item.eventName}&returnUrl=${returnUrl}`}"
                                                     replace
                                                     :title="$t('buttons.open')">
                                            <i class="fa fa-external-link-alt"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <span class="text-danger">{{$t('home.noData')}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <router-link :to="{ path: '/account?tab=activeFormsTab'}" replace class="card-link">{{$t('home.showMore')}}</router-link>
                </div>
            </div>
        </div>

        <div class="mb-3 col-md-6 col-sm-12">
            <div class="card h-100">
                <div class="card-header">
                    <h5 class="card-title">{{$t('home.myLastActionLogs')}}</h5>
                </div>
                <div class="card-body">
                    <div v-if="myActionLogs.length">
                        <ActionLogCard v-for="log in myActionLogs"
                                       :key="log.id"
                                       :log="log">
                        </ActionLogCard>
                    </div>
                    <div v-else>
                        <span class="text-danger">{{$t('home.noData')}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <router-link :to="{ path: '/logs'}" replace class="card-link">{{$t('home.showMore')}}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ActionLogCard from '../../components/administration/audit/ActionLogCard'
    import bus from '../../components/sidemenu/event-bus';
    import { mapGetters } from 'vuex'

    export default {
        props: {
            returnUrl: {
                type: String,
                default: ''
            }
        },
        components: {
            ActionLogCard
        },
        data() {
            return {
                myParticipations: [],
                myForms: [],
                myActionLogs: [],
            };
        },
        methods: {
            navigate(path) {
                return location.href.split('#')[0] + '#' + path;
                // this.$router.push(path);
            },
            crearMyActionLogs() {
                if (this.myActionLogs.length) {
                    while (this.myActionLogs.length > 0) {
                        this.myActionLogs.pop();
                    }
                }
            },
            loadMyActionLogs() {
                this.$http
                    .get(`api/ActionLog/myLast/${5}`)
                    .then(result => {
                        this.crearMyActionLogs();

                        if (result.data.length) {
                            result.data.forEach(item => {
                                this.myActionLogs.push(item);
                            })
                        }
                    })
                    .catch(err => console.log(err));
            },
            loadParticipations() {
                this.$http
                    .get('api/Participant/UsersParticipations')
                    .then(result => {
                        this.myParticipations = result.data;
                    })
                    .catch(err => console.log(err));
            },
            loadMyForms() {
                this.$http
                    .post('api/dynamicForms/listMy', { Request: { take: 5 } })
                    .then(result => {
                        this.myForms = result.data.data;
                    })
                    .catch(err => console.log(err));
            },
            onActionLogCreate(userId) {
                if (userId && this.currentUserId === userId) {
                    this.loadMyActionLogs();
                }
            }
        },
        mounted() {
            this.loadParticipations();
            this.loadMyForms();
            this.loadMyActionLogs();
        },
        created() {
            this.bus = bus;

            this.bus.$on('action-log-create', this.onActionLogCreate);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('action-log-create', this.onActionLogCreate);
        },
        computed: {
            ...mapGetters(['userId']),
            currentUserId() {
                return this.userId;
            }
        }
    };
</script>

<style>
</style>
